import { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
const Formulario = () => {
    //Hooks para validar
    const [cuentaOK, setCuentaOk] = useState(false);
    const [terminos, setTerminos] = useState(false);
    const [clientToken, setClientToken] = useState([]);
    const [scripOK, setScriptOK] = useState(false)
    //Cargar Capcha
    useEffect(() => {
        /* Script rcapcha */
        var script = document.createElement('script');
        script.src = "https://www.google.com/recaptcha/api.js?render=6LcnOiImAAAAAB4rwZivy9OMGQShw_MPU7lY0Z5A";
        document.getElementsByTagName('head')[0].appendChild(script);
        setScriptOK(true)
    }, [])

    //Variables para el registro
    let idCuentaHabiente = useRef("");
    const [idCuenta, setIdCuenta] = useState("");
    const [image, setImage] = useState("")
    let nameCouple1 = useRef("");
    let lastNameCouple1 = useRef("");
    let phoneCouple1 = useRef("");
    let genderCouple1 = useRef("");
    let ageCouple1 = useRef("");
    let nameCouple2 = useRef("");
    let lastNameCouple2 = useRef("");
    let genderCouple2 = useRef("");
    let ageCouple2 = useRef("");
    let state = useRef("");
    let history = useRef("");


    function showToast(typeToast, message) {
        let varToast;
        switch (typeToast) {
            case "success":
                varToast = toast.success;
                break;
            case "warning":
                varToast = toast.warning;
                break;
            case "error":
                varToast = toast.error;
                break;
            default:
                varToast = toast.info;
        }
        varToast(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
    //obtener token mmkg
    useEffect(() => {
        axios({
            url: process.env.REACT_APP_API + "/oauth/token",
            method: "POST",
            data: {
                grant_type: "client_credentials",
                client_id: process.env.REACT_APP_CLIENT,
                client_secret: process.env.REACT_APP_SECRET
            }
        }).then((response) => {
            setClientToken(response.data.access_token);
        }).catch((e) => {
            console.error("Error al obtener el token de autenticación");
        });
    }, []);

    //Validaciones
    function check() {
        if (terminos !== false) {
            setTerminos(false);
        } else {
            setTerminos(true);
        }
    }
    function ValidarInputs() {
        if (cuentaOK === true) {
            let inputs = [idCuentaHabiente, genderCouple1, ageCouple1, genderCouple2, ageCouple2, nameCouple1, lastNameCouple1, nameCouple2, lastNameCouple2, phoneCouple1, state, history]
            let idsInputs = ["id_cuentahabiente", "iam", "myAge", "to", "toAge", "marry_one_name", "marry_one_lastname", "marry_two_name", "marry_two_lastname", "phone", "state", "history"]
            let errorsStep = [];
            let errorsTelefono = [];
            let errorPicture = [];
            let errorTerms = [];

            for (let i = 0; i < inputs.length; i++) {
                document.getElementById(idsInputs[i]).classList = "form-control";
                document.getElementById(idsInputs[i]).style.cssText = "border:1px solid gray;";
                if (inputs[i].current.value.length === 0) {
                    document.getElementById(idsInputs[i]).style.cssText =
                        "border:1px solid red !important;";
                    document.getElementById(idsInputs[i]).classList.add("is-invalid");
                    errorsStep.push("is-invalid");
                } else {
                    errorsStep.push("is-valid");
                    document.getElementById(idsInputs[i]).classList.add("is-valid");
                }
            }

            if (!/^\d{10}$/.test(phoneCouple1.current.value)) {
                document.getElementById("phone").style.cssText =
                    "border:1px solid red !important;";
                document.getElementById("phone").classList.add("is-invalid");
                errorsTelefono.push("is-invalid");
            } else {
                document.getElementById("phone").classList = "form-control";
                document.getElementById("phone").style.cssText =
                    "border:1px solid gray;";
                document.getElementById("phone").classList.add("is-valid");
            }

            if (image.length === 0) {
                document.getElementById("picture").style.cssText = "border:1px solid red !important;";
                document.getElementById("picture").classList.add("is-invalid");
                errorPicture.push("is-invalid");
            } else {
                document.getElementById("picture").classList = "form-control";
                document.getElementById("picture").style.cssText = "border:1px solid gray;";
                document.getElementById("picture").classList.add("is-valid");
            }

            if (terminos !== true) {
                document.getElementById("terms1").style.cssText = "color: red !important;";
                errorTerms.push("is-invalid");
            } else {
                document.getElementById("terms1").style.cssText = "color: black !important;";
            }

            if (errorsStep.includes("is-invalid")) {
                showToast("error", "Llena los datos faltantes");
                toast.clearWaitingQueue();
                return false;
            } else if (errorsTelefono.includes("is-invalid")) {
                showToast("error", "Formato del número telefonico incorrecto");
                toast.clearWaitingQueue();
                return false;
            } else if (errorPicture.includes("is-invalid")) {
                showToast("error", "Agrega tu imagen");
                toast.clearWaitingQueue();
                return false;
            } else if (errorTerms.includes("is-invalid")) {
                showToast("error", "Acepta los terminos y condiones");
                toast.clearWaitingQueue();
                return false;
            } else {
                setTimeout(() => {
                    Verificar();
                }, 500);
            }


        } else {
            showToast("error", "No haz validado tu Id de CuentaHabiente");
            document.getElementById("id_cuentahabiente").style.cssText =
                "border:1px solid red !important;";
            document.getElementById("id_cuentahabiente").classList.add("is-invalid");
        }



    }

    //Verificar capcha
    function Verificar() {
        if (scripOK === true) {
            window.grecaptcha.ready(function () {
                window.grecaptcha.execute('6LcnOiImAAAAAB4rwZivy9OMGQShw_MPU7lY0Z5A', { action: 'submit' }).then(function (token) {
                    EnviarDatos(token)
                });
            });
        }
    }
    function ValidateCuenta() {
        if (idCuentaHabiente.current.value !== "") {
            axios({
                url: process.env.REACT_APP_API + "/api/users/account_num/" + idCuentaHabiente.current.value,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((response) => {
                    if (response.data.status === true) {
                        setIdCuenta(response.data.data.id)
                        showToast("success", "ID Cuentahabiente Validado");
                        document.getElementById("id_cuentahabiente").style.cssText = "border:1px solid gray;";
                        document.getElementById("id_cuentahabiente").classList.add("is-valid");
                        nameCouple1.current.value = response.data.data.name;
                        lastNameCouple1.current.value = response.data.data.lastname
                        setCuentaOk(true)
                    } else {
                        showToast("error", response.data.message);
                        toast.clearWaitingQueue();
                    }
                })
                .catch((e) => {
                    console.error("error de axios " + e);
                });
        } else {
            showToast("error", "Valida tu id de Cuentahabiente");
            toast.clearWaitingQueue();
        }
    }


    function SendImg(e) {

        let files = e.target.files || e.dataTransfer.files;

        var formData = new FormData();
        formData.append("picture", files[0]);

        axios({
            url: process.env.REACT_APP_API + "/api/casate/store-picture",
            method: 'POST',
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            },
            data: formData,
        })
            .then((response) => {
                setImage(response.data.fileName)
            })
            .catch((e) => {
                console.error(e);
            })
    }


    function EnviarDatos(token) {
        let data = {
            user_id: idCuenta,
            microsite_id: 108,
            myName: nameCouple1.current.value,
            myLastName: lastNameCouple1.current.value,
            phone: phoneCouple1.current.value,
            myGender: genderCouple1.current.value,
            age: ageCouple1.current.value,
            picture: image,
            iWantToMarry: genderCouple2.current.value,
            iWantToMarryName: nameCouple2.current.value,
            iWantToMarryLastName: lastNameCouple2.current.value,
            herAge: ageCouple2.current.value,
            state: state.current.value,
            history: history.current.value,
            token: token,
        }
        axios({
            url: process.env.REACT_APP_API + "/api/casate",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Bearer " + clientToken
            },
            data: data,
        })
            .then((response) => {
                if (response.data.status == true) {
                    showToast("success", response.data.message);
                    toast.clearWaitingQueue();
                    clear()
                    setTimeout(() => {
                        window.location.reload()
                    }, 3000)
                } else {
                    showToast("error", response.data.message);
                    toast.clearWaitingQueue();
                    clear()
                }
            })
            .catch((e) => {
                showToast("warning", e);
                toast.clearWaitingQueue();
                clear()
            })
    }
    function clear() {
        let inputs = [idCuentaHabiente, genderCouple1, ageCouple1, genderCouple2, ageCouple2, nameCouple1, lastNameCouple1, nameCouple2, lastNameCouple2, phoneCouple1, state, history]
        let idsInputs = ["id_cuentahabiente", "iam", "myAge", "to", "toAge", "marry_one_name", "marry_one_lastname", "marry_two_name", "marry_two_lastname", "phone", "state", "history"]
        for (let i = 0; i < inputs.length; i++) {
            inputs[i].current.value = ""
            document.getElementById(idsInputs[i]).classList.remove("is-valid");
        }
        setCuentaOk(false)
        document.getElementById("picture").style.cssText = "border:1px solid gray;";
        document.getElementById("picture").classList.remove("is-valid");
        let input = document.getElementById("picture");
        input.value = ''
        setImage("")
        document.getElementById("terms").checked = false;
        setTerminos(false)
    }
    const twowns = [
        "Extranjero",
        "Aguascalientes",
        "Baja California",
        "Baja California Sur",
        "Campeche",
        "Chiapas",
        "Chihuahua",
        "Coahuila",
        "Colima",
        "CDMX",
        "Durango",
        "Guanajuato",
        "Guerrero",
        "Hidalgo",
        "Jalisco",
        "México",
        "Michoacan",
        "Morelos",
        "Nayarit",
        "Nuevo Leon",
        "Oaxaca",
        "Puebla",
        "Querétaro",
        "Quintana Roo",
        "San Luis Potosi",
        "Sinaloa",
        "Sonora",
        "Tabasco",
        "Tamaulipas",
        "Tlaxcala",
        "Veracruz",
        "Yucatan",
        "Zacatecas",
    ];

    return (
        <div className="container">
            <ToastContainer limit={1} />
            <div className="row justify-content-center mt-2 mt-sm-4">
                <div className="col-12">

                    <div className="registro-card form">
                        <div className="row">
                            <div className="col-12">
                                <h1 className='titulosform mb-4 text-uppercase'><strong className='textobold'>PASO 1:</strong> Regístrate</h1>
                                <div className="input-group mb-3">
                                    <input className="form-control" type="text" id="id_cuentahabiente" name="id_cuentahabiente" placeholder="ID CUENTAHABIENTE" ref={idCuentaHabiente} onChange={() => setCuentaOk(false)} required />
                                    {cuentaOK === true || idCuentaHabiente === "" ?
                                        <button id="btnRegistro" type="button" className="btn btn-success" disabled>Validado</button>
                                        :
                                        <button id="btnRegistro" type="button" className="btn btn-validar" onClick={() => ValidateCuenta()}>Validar</button>
                                    }
                                </div>
                                <p className="form-text text-start fw-bold"><a href={process.env.REACT_APP_API + "/registro"} target="_blank">SACA AQUÍ TU ID</a></p>
                            </div>
                            <div className="col-6">
                                <label className='mb-1' htmlFor="iam">Soy: </label>
                                <select id="iam" className="form-control mb-3" name="iam" ref={genderCouple1} required>
                                    <option value="">.: Selecciona una opción :.</option>
                                    <option value="Hombre">Hombre</option>
                                    <option value="Mujer">Mujer</option>
                                    <option value="Otro">Otro</option>
                                </select>
                            </div>
                            <div className="col-6">
                                <label className='mb-1' htmlFor="myAge">Mi Edad: </label>
                                <input id="myAge" className="form-control mb-3" type="number" name="myAge" required ref={ageCouple1} />
                            </div>
                            <div className="col">
                                <label className='mb-1' htmlFor="to">Me quiero casar con: </label>
                                <select id="to" className="form-control" name="to" ref={genderCouple2} required>
                                    <option value="">.: Selecciona una opción :.</option>
                                    <option value="Hombre">Hombre</option>
                                    <option value="Mujer">Mujer</option>
                                    <option value="Otro">Otro</option>
                                </select>
                            </div>
                            <div className="col">
                                <label className='mb-1' htmlFor="toAge">Su Edad: </label>
                                <input id="toAge" className="form-control " type="number" name="toAge" ref={ageCouple2} required />
                            </div>
                        </div>
                        <div className="row pt-5">
                            <div className="col-12 pb-3 ">
                                <h6 className='textobold' htmlFor="none">Nombre completo de los novios</h6>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <input className="form-control " type="text" id="marry_one_name" name="marry_one_name" placeholder="Mi Nombre(s)" ref={nameCouple1} required />
                            </div>
                            <div className="col">
                                <input className="form-control " type="text" id="marry_one_lastname" name="marry_one_lastname" placeholder="Mis Apellidos" ref={lastNameCouple1} required />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <input className="form-control " type="text" id="marry_two_name" name="marry_two_name" placeholder="Su Nombre(s)" ref={nameCouple2} required />
                            </div>
                            <div className="col">
                                <input className="form-control " type="text" id="marry_two_lastname" name="marry_two_lastname" placeholder="Sus Apellidos" ref={lastNameCouple2} required />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <input className="form-control text-center " type="number" maxLength="10" id="phone" name="phone" placeholder="Número telefónico" ref={phoneCouple1} required />
                            </div>
                        </div>
                        <div className="row mt-3">

                            <div className="col">
                                <select id="state" className="form-control text-center" name="state" ref={state} required>
                                    <option value="">.: Selecciona un estado :.</option>
                                    {twowns.map((state, index) => (
                                        <option key={index} value={state}>{state}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="row mt-3 pt-5">
                            <h1 className='titulosform mb-4 text-uppercase'><strong className='textobold'>PASO 2:</strong> Participa </h1>
                            <div className="col-12">
                                <textarea id="history" className="form-control " name="history" maxLength="1000" placeholder="Tienes 1000 caracteres (letras) para contármela" ref={history} required></textarea>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col">
                                <h6 className='textobold mb-4' htmlFor="picture">Suban una foto juntos</h6>
                                <input id="picture" className="form-control image mt-2" type="file" name="picture" accept="image/*" onChange={SendImg} required />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 pt-5">
                                <div className="form-check">
                                    <input id="terms" className="form-check-input" type="checkbox" name="terms" onChange={() => check()} required />
                                    <label id="terms1" htmlFor="termas" className="form-check-label">He leido y acepto los <a href="https://www.marthadebayle.com/politica-de-privacidad" target="_blank">términos y condiciones</a></label>
                                </div>
                            </div>
                            <div className="col-12">
                                <button id="btnRegistro" type="submit" className="btn btn-registrar mt-5" onClick={ValidarInputs}>TERMINAR</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
export default Formulario;
